var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,_vm._b({tag:"component",staticClass:"ru:navigation__item ru:navigation__child",attrs:{"to":_vm.to,"href":_vm.to}},'component',_vm.newTabAttributes,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }